import React from 'react';
import RemoveModalTemplate from '@component/gridgio/modal/dialog-modal/remove-modal-template';
import { useTypedDispatch } from '@hook/common/useStore';
import { useRemoveWorkMutation } from '@hook/gridgio/useApi';
import { actions as modalActions } from '@store/slice/gridgio/modal-slice';
import type { IWorkRemoveModalData } from '@datatype/gridgio/type';

interface IProps {
  data: IWorkRemoveModalData['data'];
}

const WorkRemoveModal: React.FC<IProps> = ({ data }) => {
  const dispatch = useTypedDispatch();
  const mutation = useRemoveWorkMutation();

  const handleCancel = () => {
    if (!mutation.isPending) dispatch(modalActions.hideModal());
  };
  const handleRemove = async () => {
    if (mutation.isPending) return;
    try {
      await mutation.mutateAsync(data);
      dispatch(modalActions.hideModal());
    } catch {}
  };

  return (
    <RemoveModalTemplate
      title='작업을 삭제할까요?'
      description='작업에 기록한 내용도 함께 삭제됩니다.'
      isPending={mutation.isPending}
      handleCancel={handleCancel}
      handleRemove={handleRemove}
    />
  );
};

export default WorkRemoveModal;
